function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagramBlack = function SvgInstagramBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.979 67.534h48.042A8.083 8.083 0 0 0 67 59.386V10.558a8.034 8.034 0 0 0-7.979-8.092H10.979A8.034 8.034 0 0 0 3 10.558v48.828a8.083 8.083 0 0 0 7.979 8.148Zm44-59.168a5.338 5.338 0 1 1-5.341 5.334 5.335 5.335 0 0 1 5.337-5.334Zm-20 9.946A16.69 16.69 0 1 1 18.565 35a16.535 16.535 0 0 1 16.407-16.688Z",
    style: {
      fill: "#1c1c1c"
    }
  }));
};
export default SvgInstagramBlack;